import { compose } from 'recompose';

import withSnackMessageHOC from '@uptime/shared/HOCs/withSnackMessageHOC';

import Marketplace from '../components/Marketplace';

export default compose(withSnackMessageHOC)(Marketplace);
